<template>
    <div>
        <router-view name="contractModal"></router-view>
        <contract-filter
            class="mb-4"
            :filters.sync="filters"
            @get-data-from-api="loadData()"
        ></contract-filter>
        <v-card>
            <v-card-title>
                <v-btn
                    color="primary"
                    class="mb-2"
                    :disabled="dataTable.loading"
                    :to="{ name: 'CadastrarContrato', params: { requesterType: 'manager' }}"
                >
                    <v-icon>add</v-icon>{{ $t('contracts.list.addItem') }}
                </v-btn>
                <v-divider class="mx-3 hidden-md-and-down mt-0" inset vertical></v-divider>
                <v-text-field
                    v-model="search.query"
                    @click:clear="clearQuery"
                    @keyup.enter="loadData()"
                    type="text"
                    prepend-icon="search"
                    :label="$t('common.search.field')"
                    clear-icon="cancel"
                    clearable
                    hide-details
                    solo
                ></v-text-field>

                <v-btn class="ml-2" color="primary" :disabled="!search.ready" @click="loadData()">{{ $t('common.search.button') }}</v-btn>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <data-table :setup.sync="dataTable" @delete-item="deleteItem"></data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import API from '@/api'
import ContractFilter from '@/components/contract/ContractFilter'
import DataTable from '@/components/DataTable'

export default {
    name: 'list-contracts',
    metaInfo () {
        return {
            title: this.$t('contracts.list.meta.title'),
            meta: [
                { name: 'description', content: this.$t('contracts.list.meta.description') },
                { name: 'keywords', content: this.$t('contracts.list.meta.keywords') }
            ]
        }
    },
    components: {
        ContractFilter,
        DataTable
    },
    data () {
        return {
            isAdmin: false,
            filters: {
                ready: false,
                fromDate: undefined,
                toDate: undefined,
                status: [],
                showInactives: undefined
            },
            search: {
                ready: true,
                query: ''
            },
            dataTable: {
                loading: true,
                itemName: this.$t('contracts.list.dataTable.itemName'),
                headers: [
                    { text: this.$t('contracts.list.dataTable.headers.contract'), value: 'contract', width: '15%' },
                    { text: this.$t('contracts.list.dataTable.headers.typePart'), value: 'typePart', width: '15%', sortable: false },
                    { text: this.$t('contracts.list.dataTable.headers.part'), value: 'part', width: '15%', sortable: false },
                    {
                        text: this.$t('contracts.list.dataTable.headers.deadline'),
                        value: 'deadline',
                        width: '15%',
                        align: 'center',
                        sortable: false
                    },
                    {
                        text: this.$t('contracts.list.dataTable.headers.validity'),
                        value: 'validity',
                        width: '10%',
                        align: 'center',
                        date: 'iso'
                    },
                    { text: this.$t('contracts.list.dataTable.headers.status'), value: 'status', width: '10%', align: 'center' },
                    { text: this.$t('contracts.list.dataTable.headers.pendingAdditive'), value: 'pendingAdditive', width: '10%', align: 'center', sortable: false }
                ],
                items: [],
                totalItems: 0,
                requesterType: 'manager',
                editParams: true,
                detailTo: 'DetalheContrato',
                editTo: 'EditarContrato',
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: [
                        'validity'
                    ],
                    sortDesc: [true],
                    sortFormated: [
                        { value: 'validity', descending: true }
                    ]
                },
                sortingTimeout: undefined,
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        '$route.path': {
            handler: function (val, oldVal) {
                if (oldVal !== val && val === '/contratos') {
                    if (window.getApp.refreshContracts) this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) {
                        clearTimeout(this.dataTable.sortingTimeout)
                    }
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.init()
        this.adminOnly()
        this.loadData()
    },
    computed: {
        isEmployee: function () {
            return window.getApp.isEmployee
        }
    },
    methods: {
        init () {
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            switch (currentUserCompany.client.type) {
            case 'manager':
                this.dataTable.headers.unshift(
                    { text: this.$t('contracts.list.dataTable.headers.department'), value: 'departmentName', width: '12%' }
                )

                this.dataTable.headers.unshift(
                    { text: this.$t('contracts.list.dataTable.headers.client'), value: 'clientName', width: '12%' }
                )
                break
            case 'managed_company':
            case 'company':
                this.dataTable.headers.unshift(
                    { text: this.$t('contracts.list.dataTable.headers.department'), value: 'departmentName', width: '12%' }
                )
                break
            default:
                break
            }
        },
        adminOnly () {
            if (this.$helpers.isAdmin()) {
                this.isAdmin = true
                this.dataTable.headers[0].width = '10%'
                this.dataTable.headers.push(
                    {
                        text: this.$t('contracts.list.dataTable.headers.actions'),
                        value: 'actions',
                        align: 'center',
                        sortable: false,
                        edit: false,
                        delete: true,
                        width: '15%'
                    }
                )
            }
        },
        clearQuery () {
            this.search.query = ''
            this.loadData()
        },
        async loadData () {
            await this.$helpers.sleep(0)
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            window.getApp.refreshContracts = false
            this.dataTable.loading = true
            this.search.ready = false
            this.filters.ready = false
            let endpoint = API.EndPoints.getAllContract

            let params = {
                query: this.search.query,
                limit: this.dataTable.pagination.itemsPerPage,
                skip: this.dataTable.pagination.page - 1,
                order: this.dataTable.pagination.sortFormated,
                fromDate: this.filters.fromDate,
                toDate: this.filters.toDate,
                part: this.filters.part,
                status: this.filters.status,
                client: this.filters.client,
                // manager: this.filters.manager,
                department: this.filters.department,
                isEmployee: this.isEmployee,
                owner: currentUserCompany.client.objectId
            }

            if (currentUserCompany.client.type === 'department') {
                params.department = [currentUserCompany.client.objectId]
                params.owner = currentUserCompany.client.parent.objectId
            }

            new API(endpoint, params).request().then(
                response => {
                    let results = response.body.result.items
                    results.forEach(result => {
                        result.clientName = (result.client) ? result.client.name : this.$t('common.notInformed')
                        result.departmentName = (result.department) ? result.department.name : this.$t('common.notInformed')
                        result.part = this.$helpers.formatContractPart(result.part)
                        result.deadline = this.$helpers.getContractLastDeadline(result.deadline, result.objectId)
                        result.status = this.$helpers.getContractStatusLabel(result.status)
                        result.pendingAdditive = (result.pendingAdditive) ? this.$t('common.yes') : this.$t('common.no')
                    })
                    this.dataTable.items = results
                    this.dataTable.totalItems = response.body.result.count
                    this.search.ready = true
                    this.filters.ready = true
                    this.dataTable.loading = false
                    this.dataTable.sortingTimeout = undefined
                },
                e => {
                    this.$helpers.requestError(e)
                }
            )
        },
        async deleteItem (item) {
            const endpoint = API.EndPoints.deleteContract
            endpoint.id = item.objectId
            let msg = ''
            await new API(endpoint).request()
                .then(() => { msg = this.$t('contracts.list.successDelete') })
                .catch(() => { msg = this.$t('contracts.list.error') })
            if (msg !== '') alert(msg)
            this.loadData()
        }
    }
}
</script>
